/* eslint-disable no-unused-vars */

import React, { useState, useEffect,useRef } from 'react';
import axios from 'axios';
import { APP_URL,BATCH_SIZE, withCredentials } from '../App';
import {encryptPayload,decryptResponse} from './CryptoUtil';
import { useNavigate } from 'react-router-dom';



const DeviceAction = () => {
  const [error, setError] = useState('');
  const navigate = useNavigate()

  const [fileName, setFileName] = useState('');  
  const [file, setFile] = useState(null);
  const [fileSize, setFileSize] = useState(0);
  const fileInputRef = useRef(null);

  const [csvContent, setCsvContent] = useState('');    
  const [jsonContent, setJsonContent] = useState(null);

  const [incorrectData, setIncorrectData] = useState([]);
  const [correctData, setCorrectData] = useState([]);
  const [correctImeiData, setCorrectImeiData] = useState([]);

  const [downloadUrl, setDownloadUrl] = useState(null);

  const [showDownloadButton, setShowDownloadButton] = useState(false);
 

  const [singleImei, setSingleImei] = useState('');

  const [readingTime, setReadingTime] = useState(0);
  const [processTime,setProcessTime]= useState(0)

  const [pleasWait ,setPleaseWait] = useState(false)
  const [processBatchWait ,setProcessBatchWait] = useState(false)
  
   const [selectedOption, setSelectedOption] = useState('');
   const [selectedBatchOption, setSelectedBatchOption] = useState('');




  //pending bulk setWallpaper
  const [pendingBulkSetWallpaper, setPendingBulkSetWallpaper] = useState(false);
  const [lastimei, setLastImei] = useState();
  const [batchfilename, setBatchFileName] = useState();

  //batch Complete
  const [batchComplete, setBatchComplete] = useState(false);


  //autoscrolling
  const tableEndRef = useRef(null);

  //show hide batch upload
  const [newBatch,setNewBatch] = useState(true);




  useEffect(()=>{
   
    const setWallpaperBatchStatus = JSON.parse(localStorage.getItem('setWallpaperBatchStatus'))
   
    try{
     
      if(setWallpaperBatchStatus.isComplete==="incomplete"){
        setNewBatch(false)
        const pendingBulkSetWallpaper=true
        setPendingBulkSetWallpaper(pendingBulkSetWallpaper)        
       
        setLastImei(setWallpaperBatchStatus.lastimei)
        setBatchFileName(setWallpaperBatchStatus.batchfilename)
        updateStatusOnServer(setWallpaperBatchStatus)

      }else{
        setNewBatch(true)
        const pendingBulkSetWallpaper=false
        setPendingBulkSetWallpaper(pendingBulkSetWallpaper)
       
        setLastImei('')
        setBatchFileName('')
        updateStatusOnServer(setWallpaperBatchStatus)

      }
  }catch(error){
     /* continue regardless of error */

  }

  },[])

  useEffect(()=>{
    if(batchComplete){
      const setWallpaperBatchStatus = JSON.parse(localStorage.getItem('setWallpaperBatchStatus'))
      updateStatusOnServer(setWallpaperBatchStatus)
      setPendingBulkSetWallpaper(false)
      localStorage.removeItem("setWallpaperBatchStatus")
      localStorage.removeItem("correctedDataSetWallpaper")
    }

  },[batchComplete,newBatch])

  const updateStatusOnServer=async(setWallpaperBatchStatus)=>{
    try{
      const isComplete= setWallpaperBatchStatus.isComplete;
      
     
      const response = await axios.post(APP_URL+'updateStatusOnServer.php',
        
      encryptPayload(  {'lastimei':setWallpaperBatchStatus.lastimei,
          'fileName':setWallpaperBatchStatus.batchfilename,
          'isComplete':isComplete,
          'statusOf':'setWallpaperfiles',
          'user':decryptResponse(JSON.parse(localStorage.getItem("userSession")).data.payload,JSON.parse(localStorage.getItem("userSession")).data.transactionId).email


        }),
        {
          withCredentials: withCredentials,
          headers: {
          'Content-Type': 'application/json',
          'X-API-Key': decryptResponse(JSON.parse(localStorage.getItem("userSession")).data.payload,JSON.parse(localStorage.getItem("userSession")).data.transactionId).token
        }})

     


    }catch(error){
      /* continue regardless of error */

    }
  }


 
  const sendRequestToServer = async (number,action) => {
   
   
    try {
      const response = await axios.post(APP_URL+'getimeidetails.php',
        encryptPayload({ "imei":number,
         "action":action,
         "filename":fileName,
         'user':decryptResponse(JSON.parse(localStorage.getItem("userSession")).data.payload,JSON.parse(localStorage.getItem("userSession")).data.transactionId).email

         }),
         {
          withCredentials: withCredentials,
          headers: {
           'Content-Type': 'application/json',
           'X-API-Key': decryptResponse(JSON.parse(localStorage.getItem("userSession")).data.payload,JSON.parse(localStorage.getItem("userSession")).data.transactionId).token
         }}
       )
      return response.data;
    } catch (error) {
      
      return { "status": "failed","message":"not found"};
    }
  };

  const processBatch = async (numbersBatch) => {
    const results = [];
    for (const number of numbersBatch) {
     
        const result = await sendRequestToServer(number);
       
       
        results.push({'imei':number,'validate':result.message});
     
        if(correctData[correctData.length-1]===number){
         
          const setWallpaperBatchStatus ={
            'lastimei':number,
            'batchfilename':fileName,
            'isComplete':'complete'
          }        
          localStorage.setItem("setWallpaperBatchStatus",JSON.stringify(setWallpaperBatchStatus))          
          setBatchComplete(true)
          setNewBatch(true)
         

        }else{
         
           
           const setWallpaperBatchStatus ={
            'lastimei':number,
            'batchfilename':fileName,
            'isComplete':'incomplete'
          }
       
         

          localStorage.setItem("setWallpaperBatchStatus",JSON.stringify(setWallpaperBatchStatus))
         
         

        }
       
       
       
     
    }
    return results;
  };
 
  const processAllNumbers = async (numbers) => {

    const startTimeProcess = performance.now();
         
    const batchSize = BATCH_SIZE;
   
    setProcessBatchWait(true)
 
    for (let i = 0; i < numbers.length; i += batchSize) {
     
       
      const batch = numbers.slice(i, i + batchSize);
      const batchResults = await processBatch(batch);
      setCorrectImeiData(prevData => [...prevData, ...batchResults]); // Append batch results to table
      await new Promise(resolve => setTimeout(resolve, 0)); // Yield to the event loop to prevent freezing
     

     
    }
    const endTimeProcess = performance.now();
   

    const timeElapsedProcess = (endTimeProcess - startTimeProcess).toFixed(2);
    setProcessTime(timeElapsedProcess);
    setProcessBatchWait(false);
   
  };

  // useEffect(()=>{
  //  if (tableEndRef.current) {
  //     tableEndRef.current.scrollIntoView({ behavior: 'smooth' });
  //   }

  // },[correctImeiData]);

  useEffect(() => {
      if (correctImeiData.length === 0) {
        window.scrollTo({ top: 0, behavior: "smooth" });
      } else if (tableEndRef.current) {
        tableEndRef.current.scrollIntoView({ behavior: "smooth" });
      }
    }, [correctImeiData]);
 
  useEffect(() => {
   
    setPleaseWait(false)
    processAllNumbers(correctData);
  }, [correctData]);
 
 
 const processWithoutFileUpload= async (selectedFile,correctData)=>{
 
     
     
      const file = selectedFile
      setFile(file)
     
      if (file) {        
        const fileType = file.type;
        if (fileType === 'text/csv') {    
         

        const formData = new FormData();
        formData.append('file', file);
        formData.append('user',decryptResponse(JSON.parse(localStorage.getItem("userSession")).data.payload,JSON.parse(localStorage.getItem("userSession")).data.transactionId).email)
                
       
       
        try {
         
           setError('');
            setCorrectData(correctData);
            localStorage.setItem("correctedDataNotify",JSON.stringify(correctData))
            updateNotificationCommandOnServer(localStorage.getItem("correctedDataNotify"))
           
             console.log("Processed successfully without file upload.");
          // const result = await response.json();
         
          // if (result.status==="success") {
           
          //   setError('');
          //   setCorrectData(correctData);
          //   localStorage.setItem("correctedDataNotify",JSON.stringify(correctData))
          //   updateNotificationCommandOnServer(localStorage.getItem("correctedDataNotify"))
           
          //  // processUploadedFile(selectedFile)        
         
          // } else {
          //   alert(result.message);
          //   setError(result.message);
          // }
       }catch (error) {
       
         
        setError('An error occurred while uploading the file.');
      }

       
      } else {
        setFile(null);
        setError('Only CSV files are allowed.');
       
      }
    }
 }


 const handleWithoutFileUpload =  (event) => {
   
    event.preventDefault()
    const selectedFile = event.target.files[0];
    const file = selectedFile
    setFile(file)
   
       
    setFileName(selectedFile.name);
   
    setFileSize(selectedFile.size);
    const reader = new FileReader();
    const startTime = performance.now();
    reader.onload = (e) => {
    const content = e.target.result;
    const validation = validateCsvContent(content);

    if (validation.isValid) {
      setCsvContent(content);
      setFile(selectedFile);
     
      setError('');
      parseCsv(content);
     
      processWithoutFileUpload(file,validation.correctData)

    } else {
      setError(validation.error);
      setIncorrectData(validation.incorrectData);
      setJsonContent(null);
      setShowDownloadButton(true);

    }
    const endTime = performance.now();
    const timeElapsed = (endTime - startTime).toFixed(2);
    setReadingTime(timeElapsed);
 
    };
    reader.readAsText(selectedFile);

   
  };
 


// const processUploadedFile= async (selectedFile,correctData, action)=>{
//   const file = selectedFile
//       setFile(file)
     
//       if (file) {        
//         const fileType = file.type;
//         if (fileType === 'text/csv') {    
         

//         const formData = new FormData();
//         formData.append('file', file);
//         formData.append('user',decryptResponse(JSON.parse(localStorage.getItem("userSession")).data.payload,JSON.parse(localStorage.getItem("userSession")).data.transactionId).email)
                
       
      
//         try {
         
//           const response = await fetch(APP_URL+'bulkSetWallpaperCopy.php', {
//             method: 'POST',
//             body: formData,
//             headers: {
//               'X-API-Key': decryptResponse(JSON.parse(localStorage.getItem("userSession")).data.payload,JSON.parse(localStorage.getItem("userSession")).data.transactionId).token
//               }
//           });
//           const result = await response.json();
         
     
//           if (result.status==="success") {
           
//             setError('');
//             setCorrectData(correctData);
//             localStorage.setItem("correctedDataSetWallpaper",JSON.stringify(correctData))
//             // updateNotificationCommandOnServer(localStorage.getItem("correctedDataSetWallpaper"))
//               updateNotificationCommandOnServer(localStorage.getItem("correctedDataSetWallpaper"),action)
           
//            // processUploadedFile(selectedFile)        
         
//           } else {
//             alert(result.message);
//             setError(result.message);
//           }
//        }catch (error) {
       
         
//         setError('An error occurred while uploading the file.');
//       }

       
//       } else {
//         setFile(null);
//         setError('Only CSV files are allowed.');
       
//       }
//     }
//  }
//   const handleFileUpload =  (event) => {
   
//     event.preventDefault()
//     const selectedFile = event.target.files[0];
//     const file = selectedFile
//     setFile(file)
   
       
//     setFileName(selectedFile.name);
   
//     setFileSize(selectedFile.size);
//     const reader = new FileReader();
//     const startTime = performance.now();
//     reader.onload = (e) => {
//     const content = e.target.result;
//     const validation = validateCsvContent(content);

//     if (validation.isValid) {
//       setCsvContent(content);
//       setFile(selectedFile);
     
//       setError('');
//       parseCsv(content);
     
//     //   processUploadedFile(file,validation.correctData)
//       processUploadedFile(selectedFile, validation.correctData, selectedBatchOption);

//     } else {
//       setError(validation.error);
//       setIncorrectData(validation.incorrectData);
//       setJsonContent(null);
//       setShowDownloadButton(true);

//     }
//     const endTime = performance.now();
//     const timeElapsed = (endTime - startTime).toFixed(2);
//     setReadingTime(timeElapsed);
 
//     };
//     reader.readAsText(selectedFile);

   
//   };

  const validateCsvContent = (content) => {
    const lines = content.trim().split('\n').filter(line => line.trim());
   
    const incorrectData = [];
    const correctData =[];
    const firstCell = lines[0].split(',');
    if(firstCell[0].trim().toLowerCase()==="sno" && firstCell[1].trim().toLowerCase()==="imei1") {
    
    for (let i = 1; i < lines.length; i++) {
      const cells = lines[i].split(',').map(cell => cell.trim());
   
      if(cells.length===2){
        for (let j = 1; j < cells.length; j++) {

          
      
          if (!/^\d{15}$/.test(cells[j].trim())) {
            const errorLine = i ;
           // const errorCellIndex = j + 1;
            const errorCellData = cells[j].trim();
            incorrectData.push({
              line: errorLine,
              error: "Invalid Length found in imei, only 15 digits allowed",
              data: errorCellData
            });
          }else{
           
            correctData.push(cells[j].trim())
           
          }  
      }

      }else{
     
        const errorLine = i ;
         // const errorCellIndex = j + 1;
        const errorCellData = cells.join('-');
          incorrectData.push({
            line: errorLine,
            error: "More than two columns found. please check your file",
            data: errorCellData
          });

      
      }


    }
  }else{
    incorrectData.push({
      line: 1,
      error: "Invalid Headers",
      data: "headers not matched"
    });

  }
    if (incorrectData.length > 0 ) {
      handleDownloadIncorrectData(incorrectData);
      return {
        isValid: false,
        error: `CSV contains incorrect format data.`,
        incorrectData: incorrectData
      };
    }else if(correctData.length>0 && incorrectData.length===0){
     
      return {
        isValid : true,
        correctData : correctData
      }
         

    }
    setPleaseWait(true)
    return { isValid: true };
  };

  //update notification command on server
  const updateNotificationCommandOnServer=async (imeilist,action)=>{
    const jsonArray = JSON.parse(imeilist);

  // Step 2: Convert array to a comma-separated string
  const imeilist1 = jsonArray.join(',');
 
    try{
      const response = await axios.put(APP_URL+"updateCommandOnServer.php",
        encryptPayload({'imeilist':imeilist1,
          'action':action,
          'user':decryptResponse(JSON.parse(localStorage.getItem("userSession")).data.payload,JSON.parse(localStorage.getItem("userSession")).data.transactionId).email

        }),
        {
          withCredentials: withCredentials,
          headers: {
          'Content-Type': 'application/json',
          'X-API-Key': decryptResponse(JSON.parse(localStorage.getItem("userSession")).data.payload,JSON.parse(localStorage.getItem("userSession")).data.transactionId).token
        }}
      )
   
     
     
    }catch(error){
      /* continue regardless of error */

    }
  }

  const parseCsv = (content) => {
    const lines = content.split('\n').filter(line => line.trim());
    const data = lines.map(line => line.split(',').map(cell => cell.trim()));
    setJsonContent(JSON.stringify(data, null, 2));
  };

  const handleUploadClick = () => {
    resetComponent()
    fileInputRef.current.click();
  };

    const handleDownloadIncorrectData = (incorrectData) => {
    const csvContent = generateCsvContent(incorrectData);
    const blob = new Blob([csvContent], { type: 'text/csv' });
    const url = URL.createObjectURL(blob);
    setDownloadUrl(url);
  };

  const generateCsvContent = (incorrectData) => {
    const lines = incorrectData.map(error => `${error.line},${error.data},${error.error}`);
    return 'Sno,Incorrect Data,Error Message\n' + lines.join('\n');
  };

 
  const resetComponent = () => {
    setFileName('');
    setError('');
    setFile(null);
    setFileSize(0);
    setCsvContent('');
    setJsonContent(null);
    setIncorrectData([]);
    setDownloadUrl(null);
    setShowDownloadButton(false);
   
    setReadingTime(0);
    setIncorrectData([])
    setCorrectData([])
    if (fileInputRef.current) {
      fileInputRef.current.value = null; // Reset the file input
    }
  };


const handleSingleImei = (e) => {
  const value = e.target.value.toUpperCase();

  // Allow partial typing of ALL or digits (max 15)
  if (/^A{0,1}L{0,1}L{0,1}$/.test(value) || /^\d{0,15}$/.test(value)) {
    setSingleImei(value);
  } else {
    // Optional: Show live validation error, or skip this alert
    alert("Only enter a 15-digit IMEI number or type 'ALL'.");
  }
};



  const handleDeviceActionTemplate = async (event) => {
    event.preventDefault();
    const imei = singleImei.trim().toUpperCase();

//   if (imei !== 'ALL' && !/^\d{15}$/.test(imei)) {
//     alert('Please enter exactly 15 digits for IMEI or type "ALL".');
//     return;
//   }

  if (imei !== 'ALL' && !/^\d{15}$/.test(imei)) {
  alert('Please enter exactly 15 digits for IMEI or type "ALL".');
  return;
}


  if (!selectedOption) {
    alert("Please select a Device Action.");
    return;
  }
   
    let action = '';
    if (selectedOption === 'REBOOT') {
      action = 'REBOOT';
    } else if (selectedOption === 'UPDATE') {
      action = 'UPDATE';
    } else {
      alert('Please select a valid action');
      return;
    } 

   
   
   try {
      const response = await axios.post(APP_URL+'adminlocknotification.php',
       encryptPayload({ "imei":singleImei,
        "action": action,
      'user':decryptResponse(JSON.parse(localStorage.getItem("userSession")).data.payload,JSON.parse(localStorage.getItem("userSession")).data.transactionId).email
     }),
        {withCredentials: withCredentials,
          headers: {
          'Content-Type': 'application/json',
          'X-API-Key': decryptResponse(JSON.parse(localStorage.getItem("userSession")).data.payload,JSON.parse(localStorage.getItem("userSession")).data.transactionId).token
        }}
      )
      
      const decryptText = decryptResponse(response.data.payload,response.data.transactionId);
      

        if (decryptText.status === 'success') {
           alert("Device Action initiated successfully.");
           //setSingleImei('')
         
        } else if (decryptText.status !== 'success'){

          if(decryptText.message==="Authorization Failed.Invalid" || decryptText.message==="Authorization Failed"){
            localStorage.removeItem('loggedin');
            localStorage.removeItem('token');   
            localStorage.removeItem('expiry');
            localStorage.removeItem('user'); 
            navigate("/")
          }else{          
        
         
            alert(decryptText.message);
          }
          
        }
      } catch (error) {
         /* continue regardless of error */
        
       
      }
    };

 
  const hidePendingBatch=()=>{
    setPendingBulkSetWallpaper(false)
  }



  const handleProcessBatch=()=>{
    setNewBatch(false)
   
    const correctData = JSON.parse(localStorage.getItem('correctedDataSetWallpaper'));
    //setCorrectImeiData(prevData => [...prevData])
 
    const lastimei = JSON.parse(localStorage.getItem('setWallpaperBatchStatus')).lastimei
    const fileName = JSON.parse(localStorage.getItem('setWallpaperBatchStatus')).batchfilename
    setBatchFileName(fileName);
    setFileName(fileName)

   
    const index = correctData.indexOf(lastimei);

    if (index !== -1) {
     
      const unFinishedCorrectedData = correctData.slice(index + 1);
      setCorrectData(unFinishedCorrectedData)
      //processAllNumbers(unFinishedCorrectedData)
    } else {
      alert("This batch cannot be processed, please start a new batch or cancel this batch")
    }
   

  }
  const handleCancelBatch=()=>{
    setNewBatch(true)
   
   
   // processAllNumbers()
  }
  const handleNewBatch=()=>{
    setNewBatch(true)
    hidePendingBatch()
   
  }


  
  const downloadCSV = () => {
    const rows = [
      ["S.No.", "IMEI", "Status"], // Table headers
      ...correctImeiData.map((item, index) => [
        index + 1,
        item.imei,
        item.validate,
      ]), // Table data
    ];

    const csvContent =
      "data:text/csv;charset=utf-8," +
      rows.map((row) => row.join(",")).join("\n");

    const encodedUri = encodeURI(csvContent);
    const link = document.createElement("a");
    link.setAttribute("href", encodedUri);
    link.setAttribute("download", "imei_data.csv");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };


  return (
    <div className="container-fluid">
      <div className="row">
       <div className="col-md-6 grid-margin transparent">
      <div className="card">
        <div className="card-body">
          <h4 className="card-title">Device Action: Single</h4>
          <form className="forms-sample" onSubmit={handleDeviceActionTemplate}>
            <div className="form-group">
              <label htmlFor="IMEI">IMEI</label>
              <div className="col-sm-12">
                
                <input
  type="text"
  placeholder="Enter IMEI or 'ALL'"
  className="form-control input-sm"
  required
  value={singleImei}
  onChange={handleSingleImei}
  autoComplete="off"
/>
<p className="p-2">Enter a 15-digit IMEI number or type <strong>ALL</strong> to apply to all devices</p>


                <p className="p-2">Please provide 15 digit IMEI number</p>
              </div>
            </div>

            <div className="form-group">
              <p>Choose A Device Action</p>
              <select
                className="form-control"
                onChange={(e) => setSelectedOption(e.target.value)}
                required
                value={selectedOption}
              >
                <option value="">----Choose a Device Action----</option>
                <option value="REBOOT">REBOOT</option>
                <option value="UPDATE">UPDATE</option>
              
              </select>
              <p className="p-2">Please select a Device Action</p>
            </div>

            <div className="submit-buttons">
              <button type="submit" className="btn btn-success me-2 btn-sm text-white">
                Submit
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
        
         <div className="col-md-6 grid-margin transparent">

         { pendingBulkSetWallpaper && (
          <div className='card' style={{marginBottom:'30px'}}>
            <div className="card-body">          
              <h4 className="card-title">Incomplete Batch Available</h4>
              <hr></hr>
              <p>Filename : {batchfilename}</p>
              <p>Last Processed Imei :{lastimei}</p>
              <hr></hr>
              <p className='text-center text-primary' >Process / Cancel / Start New Batch </p>
              <p className='text-center'>
                <button className="btn btn-success btn-sm text-white marginLeftRight" onClick={handleProcessBatch}>Process</button> <span></span>
                <button className="btn btn-danger btn-sm text-white marginLeftRight" onClick={handleCancelBatch}>Cancel</button> <span></span>
                <button className="btn btn-primary btn-sm text-white marginLeftRight" onClick={handleNewBatch}>New Batch</button>
             
              </p>
            </div>

          </div>

          )}

          {newBatch &&(<div className="card">
            <div className="card-body">
              <h4 className="card-title">Device Action: Batch Process Without File upload</h4>
              <form className="forms-sample" >
                <div className="form-group">
                
                  <label htmlFor="File Upload">File upload</label>
                  <input
                    type="file"
                    className="file-upload-default"
                    id="fileInput"
                    ref={fileInputRef}
                    style={{ display: 'none' }}
                    onChange={handleWithoutFileUpload}
                  />
                 
                  <div className="input-group">
                    <input
                      type="text"
                      className="form-control input-sm file-upload-info"
                      disabled
                      placeholder="Upload CSV"
                      value={fileName}
                    />
                    <span className="input-group-append">
                      <button
                        className="file-upload-browse btn btn-primary btn-sm"
                        type="button"
                        onClick={handleUploadClick}
                      >
                        Select File
                      </button>
                    </span>
                  </div>
                </div>
                {error && <p className="text-danger">{error}</p>}
                {file && (
                  <p>
                    File Details : {file.name} ({(fileSize / 1024).toFixed(2)} KB)
                    {readingTime > 0 && `<br/> - Reading time: ${readingTime} ms`}
                  </p>
                )}
                {incorrectData.length > 0 && (
                  <div className="invalid-imei-container">
                    <div className="row d d-flex ">
                      <h4 className="col-md-4 mx-3">Invalid IMEI:</h4>
                      {downloadUrl && (
                        <a
                          className=""
                          href={downloadUrl}
                          download="incorrect_data.csv"
                        >
                          Click here to download
                        </a>
                      )}
                    </div>
                    <p>
                      File size: {(fileSize / 1024).toFixed(2)} KB
                      <span className="mx-2">|</span>
                      Reading time: {readingTime} ms
                    </p>

                   
               
                  </div>
                )}
                {/* {jsonContent && (
                  <div className="json-content-container">
                    <h4>CSV Content in JSON format:</h4>
                    <pre>{jsonContent}</pre>
                  </div>
                )} */}
             
              </form>
            </div>
          </div>)
       }


        </div>

        
        
       
        <div className="row">
         <div className="col-md-12 grid-margin transparent">
         {pleasWait && (
          <div className="loading-message">
              <div className="spinner"></div>
            <p>Please wait while we evaluate this batch. You are requested not to refresh/reload/or navigate </p>
           
           
          </div>
        )}


      {processBatchWait && (
          <div className="loading-message">
           
            <div className="spinner"></div>
            <p >Please Wait while we are executing this batch.You are requested not to refresh/reload/or navigate .</p>
           
         
          </div>
        )}

       
        {batchComplete &&(
          <div>
            <br></br>
            <p>Process Time : {processTime} ms</p>
          </div>
        )}
       
         
       
         <p style={{backgroundColor: 'white',padding:5}}> Batch Summary - Total {correctData.length + incorrectData.length} || <span style={{color:'green'}}>Valid IMEI :{correctData.length} </span>||<span style={{color:'red'}}>Invalid IMEI :{incorrectData.length} </span> ||<span style={{color:'green'}}> Found {correctImeiData.filter((item)=>{return item.validate==="found"}).length}</span> ||<span style={{color:'red'}}> Not Found {correctImeiData.filter((item)=>{return item.validate==="not found"}).length}</span></p>
        
         <div className="row mb-3" style={{ marginBottom: "20px", justifyContent: "flex-end" }}>
        <button
          className="btn btn-info btn-sm text-white"
          onClick={downloadCSV}
          disabled={correctImeiData.length === 0} // Disable if there's no data
          style={{ marginRight: "10px", width: "auto" }}
        >
          Download CSV
        </button>
      </div>
        
        
         <div style={{height:'350px',overflow:'scroll'}}>
         <table className="table table-bordered mt-3">
                      <thead>
                        <tr>
                        <th>S.No.</th>
                          <th>IMEI</th>
                          <th>Status</th>
                         
                        </tr>
                      </thead>
                      <tbody>
                        {correctImeiData.map((item, index) => (
                          <tr key={item.imei} >
                             <td>{index+1}</td>
                            <td>{item.imei}</td>
                            <td>{item.validate}</td>
                           
                           
                          </tr>
                        ))}
                        <tr ref={tableEndRef}></tr>
                      </tbody>
                    </table>
          </div>
         </div>
        </div>
      </div>
    </div>
  );
};
DeviceAction.displayName = "DeviceAction"
export default DeviceAction;
